import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const GanttIcon: React.FC<IconProps> = props => (
  <Icon fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 4C14.1046 4 15 4.89543 15 6V9H22C23.1046 9 24 9.89543 24 11V14C24 15.0357 23.2128 15.887 22.2041 15.9893L22 16H19V19C19 20.0357 18.2128 20.887 17.2041 20.9893L17 21H7L6.7959 20.9893C5.85435 20.8938 5.1062 20.1457 5.01074 19.2041L5 19V16C5 14.8954 5.89543 14 7 14H10V11H3L2.7959 10.9893C1.85435 10.8938 1.1062 10.1457 1.01074 9.2041L1 9V6C1 4.89543 1.89543 4 3 4H13ZM7 19H17V16H7V19ZM12 14H22V11H12V14ZM3 9H13V6H3V9Z"
    />
  </Icon>
)
